<template>
    <section class="list-delivery-summary">
        <DeliverySummary
            v-for="( delivery, index ) in inProgressDeliveryList"
            :key="index"
            :deliveryInfo="delivery"
            class="delivery-summary"
        />
    </section>
</template>

<script>
// Components
import DeliverySummary from './listDeliverySummary/DeliverySummary';

export default {
    name: 'ListDeliverySummary',
    components: {
        DeliverySummary,
    },
    props: {
        inProgressDeliveryList: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss">

.list-delivery-summary {
    >*:not(:last-child) {
        margin-bottom: 1rem;
    }
}
.delivery-summary {}

@include mixins-above(tablet) {
    //
}
</style>
